import fetchDato from './fetchDato';
import { asyncable } from 'svelte-asyncable';

let body = `{
    allLocations {
      coordinates {
        latitude
        longitude
      }
      id
      name
      description
      images {
        url
      }
    }}`;


async function getAllPins() {
    const pins = await fetchDato(body).then( r=> r.allLocations );
    return pins
};

let firstRun = true
export const pinsStore = asyncable(async () => {
  return await getAllPins();

});



